<template>
  <v-app id="inspire">
    <div class="login-page">
      <div class="login-page__glow login-page__glow--green"></div>
      <div class="login-page__glow login-page__glow--navy"></div>
      <div class="login-page__grid"></div>

      <button type="button" class="login-back" :title="$t('login.backToHome')" @click="$router.push('/')">
        <v-icon color="#0c2461" size="20">mdi-arrow-left</v-icon>
        <span class="login-back__text">{{ $t('login.backToHome') }}</span>
      </button>

      <div class="login-card">
        <div class="login-card__head">
          <img src="../../assets/urbanGo.png" alt="urbanGo" height="56" />
          <h1 class="login-card__title">{{ $t('login.title') }}</h1>
          <p class="login-card__subtitle">{{ $t('login.subtitle') }}</p>
        </div>

        <form class="login-form" novalidate @submit.prevent="login">
          <div class="mb-3">
            <label for="login-username" class="form-label login-label">{{ $t('login.usernameLabel') }}</label>
            <input
              id="login-username"
              v-model.trim="$v.userLogin.login.$model"
              type="text"
              class="form-control login-input"
              :class="{ 'is-invalid': usernameError.length }"
              :placeholder="$t('login.usernamePlaceholder')"
              autocomplete="username"
              @blur="$v.userLogin.login.$touch()"
            />
            <div class="invalid-feedback">{{ usernameError[0] }}</div>
          </div>

          <div class="mb-3">
            <label for="login-password" class="form-label login-label">{{ $t('login.passwordLabel') }}</label>
            <div class="input-group has-validation">
              <input
                id="login-password"
                v-model.trim="$v.userLogin.password.$model"
                :type="passwordIsVisible ? 'text' : 'password'"
                class="form-control login-input"
                :class="{ 'is-invalid': passwordError.length }"
                :placeholder="$t('login.passwordPlaceholder')"
                autocomplete="current-password"
                @blur="$v.userLogin.password.$touch()"
              />
              <button
                type="button"
                class="btn login-toggle"
                :class="{ 'is-invalid': passwordError.length }"
                @click="passwordIsVisible = !passwordIsVisible"
              >
                <v-icon color="#64748b" size="20">
                  {{ passwordIsVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
                </v-icon>
              </button>
              <div class="invalid-feedback">{{ passwordError[0] }}</div>
            </div>
          </div>

          <button type="submit" class="login-submit" :disabled="isLoading">
            <span v-if="isLoading" class="login-spinner"></span>
            <span v-else>{{ $t('login.submitBtn') }}</span>
          </button>
        </form>

        <div class="login-card__alt">
          {{ $t('login.noAccount') }}
          <a href="#" @click.prevent="$router.push('/DemandeAdhesion')">{{ $t('login.registerCompany') }}</a>
        </div>
      </div>

      <div class="login-copy">© {{ new Date().getFullYear() }} urbanGo. Tous droits réservés.</div>
    </div>
  </v-app>
</template>

<script>
//import axios from "axios";
//import { API_LOGIN_USER } from "../globalConfig/globalConstConfig";
import { required } from "vuelidate/lib/validators";
import userAuth from "@/api/endpoints/userAuth";
export default {
  name: "LoginVue",
  data() {
    return {
      overlay: false,
      passwordIsVisible: false,
      isLoading: false,
      errorMsg: "",

      userLoginData: {
        data: {
          login: null,
          password: null,
        },
      },

      userLogin: {
        login: null,
        password: null,
      },
    };
  },

  validations: {
    userLogin: {
      login: {
        required,
      },

      password: {
        required,
      },
    },
  },

  methods: {
    //SOUMISSION FORMULAIRE
    submitForm() { },

    async login() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$swal.fire({
          title: this.$t('login.emptyFieldsTitle'),
          text: this.$t('login.emptyFieldsMessage'),
          icon: "warning",
          confirmButtonColor: "#159e72",
        });
        return;
      }

      this.userLoginData.data.login = this.userLogin.login;
      this.userLoginData.data.password = this.userLogin.password;
      this.isLoading = true;

      try {
        const response = await userAuth.login(this.userLoginData);

        if (response.data.status.code !== "800") {
          this.$swal.fire({
            title: this.$t('login.errorTitle'),
            text: response.data.status.message,
            icon: "error",
            confirmButtonColor: "#159e72",
          });
          return;
        } else {
          await this.$store.dispatch('setUser', response.data.item);
          this.redirectAfterLogin();
        }
      } catch (e) {
        if (e.code === 'ECONNABORTED') {
          this.$swal.fire({
            title: this.$t('login.timeoutTitle'),
            text: this.$t('login.timeoutMessage'),
            icon: "warning",
            confirmButtonColor: "#159e72",
          });
        } else {
          this.$swal.fire({
            title: this.$t('login.networkErrorTitle'),
            text: this.$t('login.networkErrorMessage'),
            icon: "error",
            confirmButtonColor: "#159e72",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    

    // RETOUR VERS LA PAGE DEMANDÉE AVANT LA CONNEXION (CHEMINS INTERNES UNIQUEMENT)
    redirectAfterLogin() {
      const redirect = this.$route.query.redirect;
      const isInternal =
        typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//");

      if (isInternal && redirect.toLowerCase() !== "/login") {
        this.$router.push(redirect);
      } else {
        this.$router.push({ name: "tableauBord" });
      }
    },

    /**
     * Cette methode permettra de détecter si nous sommes sur la page de connexion (/connexion).
     * Si c'est le cas , l'utilisateur perd sa session et sera invité de saisir
     * à nouveau ses paramètres de connexion
     */
    initializeSession() { },
  },

  computed: {
    //GESTION DES CONTRAINTES (SAISIE UTILISATEUR)
    usernameError() {
      const errors = [];
      if (!this.$v.userLogin.login.$dirty) return errors;
      !this.$v.userLogin.login.required &&
        errors.push(this.$t('login.usernameRequired'));
      return errors;
    },

    passwordError() {
      const errors = [];
      if (!this.$v.userLogin.password.$dirty) return errors;
      !this.$v.userLogin.password.required &&
        errors.push(this.$t('login.passwordRequired'));
      return errors;
    },
  },

  mounted() {
    // Animations CSS natives, plus besoin de jQuery
  },
};
</script>

<style lang="scss" scoped>
$green: #159e72;
$green-dark: #11845f;
$teal: #079992;
$navy: #0c2461;
$ink: #0f172a;
$muted: #475569;
$line: rgba(15, 23, 42, 0.08);

@keyframes login-fade-up {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}

.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 88px 16px 56px;
  background: linear-gradient(180deg, #f3fbf8 0%, #ffffff 75%);
}

.login-page__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;

  &--green {
    width: 520px;
    height: 520px;
    top: -200px;
    right: -140px;
    background: rgba(21, 158, 114, 0.22);
  }

  &--navy {
    width: 440px;
    height: 440px;
    bottom: -220px;
    left: -160px;
    background: rgba(12, 36, 97, 0.12);
  }
}

.login-page__grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(12, 36, 97, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(12, 36, 97, 0.05) 1px, transparent 1px);
  background-size: 48px 48px;
  -webkit-mask-image: radial-gradient(ellipse at 50% 40%, #000 0%, transparent 65%);
  mask-image: radial-gradient(ellipse at 50% 40%, #000 0%, transparent 65%);
}

/* RETOUR */
.login-back {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 8px 10px;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: $navy;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateX(-2px);
    border-color: rgba(12, 36, 97, 0.25);
  }
}

/* CARTE */
.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 20px;
  padding: 40px 36px 32px;
  box-shadow: 0 30px 60px -16px rgba(12, 36, 97, 0.18), 0 12px 24px -10px rgba(12, 36, 97, 0.08);
  animation: login-fade-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.login-card__head {
  text-align: center;
  margin-bottom: 28px;

  img {
    margin-bottom: 18px;
  }
}

.login-card__title {
  font-size: 26px;
  font-weight: 900;
  color: $navy;
  letter-spacing: -0.5px;
  margin-bottom: 6px;
}

.login-card__subtitle {
  font-size: 14px;
  line-height: 1.6;
  color: $muted;
  margin: 0;
}

/* FORMULAIRE */
.login-label {
  font-size: 13px;
  font-weight: 700;
  color: $ink;
}

.login-input {
  height: 46px;
  font-size: 14px;
  color: $ink;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &::placeholder {
    color: #94a3b8;
  }

  &:focus {
    background: #ffffff;
    border-color: $green;
    box-shadow: 0 0 0 3px rgba(21, 158, 114, 0.15);
  }

  &.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.15);
  }
}

.input-group .login-input {
  border-right: none;
}

.login-toggle {
  display: flex;
  align-items: center;
  padding: 0 14px;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-left: none;
  border-radius: 0 10px 10px 0;

  &.is-invalid {
    border-color: #dc3545;
  }
}

.input-group:focus-within .login-toggle {
  background: #ffffff;
  border-color: $green;
}

.input-group:focus-within .login-toggle.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  font-size: 12px;
}

.login-submit {
  width: 100%;
  height: 48px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, $green 0%, $green-dark 100%);
  box-shadow: 0 8px 20px rgba(21, 158, 114, 0.28);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 12px 28px rgba(21, 158, 114, 0.38);
  }

  &:disabled {
    opacity: 0.75;
    cursor: wait;
  }
}

.login-spinner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  animation: login-spin 0.8s linear infinite;
}

.login-card__alt {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid $line;
  text-align: center;
  font-size: 13px;
  color: $muted;

  a {
    display: inline-block;
    margin-top: 2px;
    font-weight: 700;
    color: $green;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.login-copy {
  position: relative;
  z-index: 1;
  margin-top: 28px;
  font-size: 12px;
  color: $muted;
}

@media (max-width: 600px) {
  .login-page {
    padding-top: 80px;
  }

  .login-back {
    top: 16px;
    left: 16px;
  }

  .login-back__text {
    display: none;
  }

  .login-back {
    padding: 8px;
  }

  .login-card {
    padding: 32px 22px 26px;
    border-radius: 18px;
  }

  .login-card__title {
    font-size: 23px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .login-card {
    animation: none;
  }
}
</style>
